__turbopack_context__.v({
  "image": "slide-el-module-scss-module__CBZEDa__image",
  "image__desktop": "slide-el-module-scss-module__CBZEDa__image__desktop",
  "image__mobile": "slide-el-module-scss-module__CBZEDa__image__mobile",
});
